// Conexão da busca de mesa da Liga da Semana: ola, buscar e espera o pareado. Fechou no meio, procura de novo.
// Com trio fixo, a busca primeiro reúne os 3 (fase 'reunindo') e depois procura com o trio junto.
import type { LigaDaSala, MensagemServidor, Perfil, TrioNaBusca, TrioReunindo } from '@truco6/mesa/protocolo';

export interface EstadoBusca {
  fase: 'conectando' | 'reunindo' | 'procurando' | 'pareado' | 'erro';
  reuniao: TrioReunindo | null; // quem do trio já pediu a busca
  trio: TrioNaBusca | null; // procurando com este trio, com os 2 parceiros
  desde: number | null; // horário do aparelho em que a busca começou
  divisao: number;
  liga: LigaDaSala | null;
  total: number | null; // pessoas procurando mesa na liga agora (trio conta 3)
  naFaixa: number; // pessoas, além de você, na faixa de divisão aberta para você
  codigo: string | null;
  andamento: { nos: number; eles: number } | null; // sentou na vaga de uma mesa em andamento: o placar, o seu trio primeiro
  erro: { codigo: string; mensagem: string } | null;
}

export class ConexaoBusca {
  private ws: WebSocket | null = null;
  private fechada = false;
  private tentativas = 0;
  estado: EstadoBusca = { fase: 'conectando', reuniao: null, trio: null, desde: null, divisao: 0, liga: null, total: null, naFaixa: 0, codigo: null, andamento: null, erro: null };
  private readonly url: string;
  private readonly token: () => Promise<string>;
  private readonly perfil: Perfil;
  private readonly aoMudar: (e: EstadoBusca) => void;
  private readonly comTrio: string | null;

  constructor(url: string, token: () => Promise<string>, perfil: Perfil, aoMudar: (e: EstadoBusca) => void, trio: string | null = null) {
    this.url = url; this.token = token; this.perfil = perfil; this.aoMudar = aoMudar; this.comTrio = trio;
  }

  private mudar(p: Partial<EstadoBusca>): void {
    this.estado = { ...this.estado, ...p };
    this.aoMudar(this.estado);
  }

  iniciar(): this {
    const ws = this.ws = new WebSocket(this.url);
    ws.onopen = () => { void this.token().then((token) => ws.send(JSON.stringify({ t: 'ola', token }))); };
    ws.onmessage = (ev) => {
      const m = JSON.parse(String(ev.data)) as MensagemServidor;
      if (m.t === 'bemvindo') {
        this.tentativas = 0;
        ws.send(JSON.stringify(this.comTrio ? { t: 'buscar', perfil: this.perfil, trio: this.comTrio } : { t: 'buscar', perfil: this.perfil }));
      } else if (m.t === 'reunindo') this.mudar({ fase: 'reunindo', reuniao: m.trio, erro: null });
      else if (m.t === 'busca') this.mudar({ fase: 'procurando', reuniao: null, trio: m.trio, desde: Date.now() - (m.agora - m.desde), divisao: m.divisao, liga: m.liga, erro: null });
      else if (m.t === 'busca_fila') this.mudar({ total: m.total, naFaixa: m.naFaixa });
      else if (m.t === 'pareado') { this.fechada = true; this.mudar({ fase: 'pareado', codigo: m.codigo, andamento: m.andamento ?? null }); ws.close(1000); }
      else if (m.t === 'erro') { this.fechada = true; this.mudar({ fase: 'erro', erro: { codigo: m.codigo, mensagem: m.mensagem } }); ws.close(1000); }
      else if (m.t === 'busca_cancelada' && !this.fechada) { this.fechada = true; ws.close(1000); }
    };
    ws.onclose = () => {
      if (this.fechada) return;
      // Caiu: procura de novo, com espera crescente.
      this.mudar({ fase: 'conectando' });
      setTimeout(() => { if (!this.fechada) this.iniciar(); }, Math.min(8000, 500 * 2 ** this.tentativas++));
    };
    return this;
  }

  cancelar(): void {
    if (this.fechada) return;
    this.fechada = true;
    try { this.ws?.send(JSON.stringify({ t: 'cancelar_busca' })); } catch { /* já fechou */ }
    this.ws?.close(1000);
  }
}
